import { render, staticRenderFns } from "./WebsiteList.vue?vue&type=template&id=1fcc18a6&scoped=true&lang=pug"
import script from "./WebsiteList.vue?vue&type=script&lang=ts"
export * from "./WebsiteList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcc18a6",
  null
  
)

export default component.exports